import { Typography, TypographyProps } from "@mui/material";
import { FC } from "react";

export const SnackbarHeader: FC<TypographyProps> = ({ children }) => {
	return (
		<Typography
			variant={"body1"}
			fontSize={"40px"}
			lineHeight={"48px"}
			fontWeight={900}
			marginBottom={0}
		>
			{children}
		</Typography>
	);
};
